import { api } from "api/api"
import IndicadorDashboard from "components/chart/IndicadorDashboard"
import { ChartBarModel } from "model/chart/ChartBarModel"
import { ChartLineModel } from "model/chart/ChartLineModel"
import { ChartPieModel } from "model/chart/ChartPieModel"
import ManutencaoDashboardTable from "model/gestao/frotas/ManutencaoDashboardTable"

export default class SuprimentosDashboardService {

    buscarChartPorProduto() {
        return new Promise<ChartPieModel>((resolve, reject): void => {
            api.get("/suprimentos/dashboard/grafico/gastoPorProduto")
            .then(response => resolve(response.data))
            .catch((err) => reject(err.response))
        })
    }

    buscarChartPorMes() {
        return new Promise<ChartBarModel>((resolve, reject): void => {
            api.get("/suprimentos/dashboard/grafico/gastoPorMes")
            .then(response => resolve(response.data))
            .catch((err) => reject(err.response))
        })
    }
    
}
